module.exports = __webpack_public_path__ + "static/demo-screen-3-359e18b4a09b5ebb3c7a513febdded15.jpg";